import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { keyframes } from "@emotion/react";
import clsx from "clsx";
import { Box } from "./Box";
import { useTheme } from "./ThemeProvider";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { alpha, mergeSx } from "../system";
export const skeletonClasses = {
    root: "MinervaSkeleton-root",
};
export const Skeleton = (props) => {
    const { animation = false, showChildren = false, width, height, color = "surface", colorSet, invertColors, children, sx, className, ...rest } = useDefaultProps({ component: "Skeleton", props });
    const pulseKeyframe = keyframes `
      from {
        opacity: 0.4;
      }
    `;
    const theme = useTheme();
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: ({ background }) => showChildren ? (children) : (_jsx(Box, { width: !children && !width ? "100%" : width, height: !children && !height ? theme.typography.body.fontSize : height, className: clsx([skeletonClasses.root, className]), sx: mergeSx({
                backgroundColor: alpha(`${background}`, 0.1),
                borderRadius: (theme) => theme.radius.default,
                // Can not overflow
                maxWidth: "100%",
                "& > *": {
                    visibility: "hidden",
                },
                animation: animation
                    ? `${pulseKeyframe} 1s ease-in-out infinite alternate`
                    : undefined,
            }, sx), ...rest, children: children })) }));
};
//# sourceMappingURL=Skeleton.js.map